module.exports = __webpack_public_path__ + "static/media/unselected.09acc3f4.svg";